<template>
  <div>
    <AppLabel :mode="mode" title="Dealer for" />
    <div class="relative z-20">
      <div class="relative flex items-center">
        <Search
          :size="20"
          :stroke-width="1.75"
          class="absolute left-4 opacity-40"
        />
        <AppInput
          :mode="mode"
          type="search"
          placeholder="Search by manufacturer"
          v-model="searchQuery"
          @focus="searchFocus = true"
          classes="!pl-11"
          :hasLabel="false"
        />
      </div>
      <div
        v-if="searchFocus"
        class="without-scrollbar absolute left-0 right-0 top-full z-10 mt-1 max-h-[210px] overflow-y-auto rounded-lg border p-4"
        :class="[
          mode === 'dark'
            ? 'border-dark-border bg-dark-sidebar'
            : 'border-black-10 bg-white-100',
        ]"
      >
        <div v-if="filteredMfrs && filteredMfrs.length > 0" class="grid gap-3">
          <AppCheckbox
            v-for="(mfr, key) in filteredMfrs"
            :key="key"
            :mode="mode"
            :id="mfr.mfr.mfr_id"
            v-model="selectedMfrs"
            :title="mfr.mfr.company"
            :value="mfr.mfr.company"
          />
        </div>
        <div v-else class="text-center">
          <span
            class="text-sm font-medium"
            :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']"
            >No manufacturers found to select</span
          >
        </div>
      </div>
    </div>
    <div
      class="fixed inset-0 z-10"
      v-if="searchFocus"
      @click="searchFocus = false"
    ></div>
    <div v-if="selectedMfrs.length > 0" class="mt-4">
      <div class="flex flex-wrap items-center gap-2">
        <span
          class="cursor-pointer rounded-md border border-primary-100 px-3 py-1 text-[13px] font-medium text-primary-100 transition-colors hover:bg-primary-100 hover:text-white-100"
          :class="[mode === 'dark' ? 'bg-dark-sidebar' : 'bg-white-100']"
          v-for="(mfr, index) in selectedMfrs"
          @click="removeSelectedMfr(index)"
          :key="index"
        >
          {{ mfr }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { Search } from "lucide-vue-next";
import AppInput from "@C/Form/AppInput.vue";
import AppCheckbox from "@C/Form/AppCheckbox.vue";
import AppLabel from "@C/Form/AppLabel.vue";

export default {
  name: "DelearFor",
  props: {
    mode: String,
    mfrs: {
      type: Array,
      default: [],
    },
  },
  components: {
    AppInput,
    AppCheckbox,
    Search,
    AppLabel,
  },
  data() {
    return {
      searchFocus: false,
      searchQuery: "",
      selectedMfrs: [],
    };
  },
  methods: {
    removeSelectedMfr(index) {
      this.selectedMfrs.splice(index, 1);
    },
  },
  computed: {
    filteredMfrs() {
      if (!this.mfrs || (this.mfrs && this.mfrs.length === 0)) {
        return;
      }
      return this.mfrs.filter((mfr) =>
        mfr.mfr.company.toLowerCase().includes(this.searchQuery.toLowerCase()),
      );
    },
  },
  watch: {
    selectedMfrs: {
      deep: true,
      handler(newValue) {
        this.$emit("selectedMfrsUpdated", newValue);
      },
    },
  },
};
</script>
